var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import AssistApply from '~/components/apply-component/assist-apply.vue';
import { namespace } from "vuex-class";
import { ApplyType, CASE_HALT_CATEGORY, MENU_CHANNEL } from "~/config/enum.config";
var CollectionExecutionModule = namespace("collection-execution");
var AssistButton = /** @class */ (function (_super) {
    __extends(AssistButton, _super);
    function AssistButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = false;
        _this.applyType = {};
        _this.otherModel = {
            caseHaltCategory: CASE_HALT_CATEGORY.CASE_HALT
        };
        _this.fromChannel = '';
        _this.disabledType = [];
        return _this;
    }
    AssistButton.prototype.onClickButton = function () {
        this.applyType = ApplyType.assist;
        var channelsVisit = [MENU_CHANNEL.Visit_team, MENU_CHANNEL.Visit_personal];
        var channelsTel = [MENU_CHANNEL.Tel_team, MENU_CHANNEL.Tel_personal];
        var channelsLegal = [MENU_CHANNEL.Legal_team, MENU_CHANNEL.Legal_personal];
        if (channelsVisit.includes(this.menuChannel)) {
            this.disabledType = ["ASSIT_VISIT"];
        }
        if (channelsTel.includes(this.menuChannel)) {
            this.disabledType = ["ASSIT_TEL"];
        }
        if (channelsLegal.includes(this.menuChannel)) {
            this.disabledType = ["ASSIT_LEGAL"];
        }
        this.dialog = true;
    };
    __decorate([
        CollectionExecutionModule.State
    ], AssistButton.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], AssistButton.prototype, "menuChannel", void 0);
    AssistButton = __decorate([
        Component({
            components: {
                AssistApply: AssistApply
            }
        })
    ], AssistButton);
    return AssistButton;
}(Vue));
export default AssistButton;
